module.exports = __webpack_public_path__ + "static/img/117.a9ffebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/117.png
// module id = A/uJ
// module chunks = 0